import React, {useCallback, useEffect} from 'react';

import {useEvent} from '../../data/hooks/eventHooks';
import {useI18n} from '../../data/hooks/i18nHooks';
import Link from '../elements/Link';
import SafeImage from '../elements/SafeImage';
import SandboxedContent from '../SandboxedContent/SandboxedContent';
import Screen from './Screen';
import Scrollable from '../elements/Scrollable';
import TopBarEvent from '../elements/TopBar/TopBarEvent';

const EventWelcomeScreen = props => {
    const {eventId} = props,
        event = useEvent(eventId),
        i18n = useI18n();

    const handleContinueClicked = useCallback(() => {
        // update locally (we don't need to wait for the server for this one; if it fails, we will just show this screen again next time)
        app.store.dispatch(app.actions.events.localUpdate(eventId, {isWelcomeScreenShown: true}));

        // send update to the server
        app.api.events.performAction(eventId, 'welcome_read', {object_id: 0}).catch(console.error);
    }, []);

    useEffect(() => {
        if (event.welcome_image_url) {
            app.store.dispatch(app.actions.ui.sidePanel.showWallpaper(event.welcome_image_url));
            return () => {
                app.store.dispatch(app.actions.ui.sidePanel.reset());
            };
        }
    }, []);

    const header = (
            <TopBarEvent event={event} returnURL="/">
                {event.name}
            </TopBarEvent>
        ),
        footer = (
            <div className="content">
                <Link type="button" className="btn btn-md" style={event._local.styles.button} onClick={handleContinueClicked}>
                    {i18n['label.continue']}
                </Link>
            </div>
        );

    return (
        <Screen header={header} footer={footer}>
            <Scrollable>
                <hr />
                <SafeImage
                    src={event.logo_url}
                    style={{
                        width: '100%',
                    }}
                />
                <hr />
                <div className="content">
                    <div className="whitebg">
                        <SandboxedContent content={event.welcome_text} fitHeightToContents />
                    </div>
                </div>
            </Scrollable>
        </Screen>
    );
};

export default EventWelcomeScreen;
